const BLOCKING_TAGS = ['INPUT', 'TEXTAREA', 'SELECT', 'VIDEO', 'AUDIO'];

export const SHORTCUT_STATUSES = {
  pending: 'PENDING',
  verified: 'VERIFIED',
  exclude: 'SUSPECT'
};

export const walkToOpenAfterExclusion = (refreshedIds, index, excludedId) => {
  if (refreshedIds.length === 0) {
    return null;
  }
  const nextId = refreshedIds[Math.min(index, refreshedIds.length - 1)];
  return nextId === excludedId ? null : nextId;
};

export const nextWalkIdAfterUpdate = async ({
  items,
  walkId,
  pageNumber,
  fetchPage
}) => {
  const ids = items.map(walk => walk.id);
  const index = ids.indexOf(walkId);
  if (index !== -1 && index < ids.length - 1) {
    return ids[index + 1];
  }
  const current = await fetchPage(pageNumber);
  if (!current) {
    return null;
  }
  const currentIds = current.map(walk => walk.id);
  const position = currentIds.indexOf(walkId);
  if (position === -1) {
    return index < currentIds.length ? currentIds[index] : null;
  }
  if (position < currentIds.length - 1) {
    return currentIds[position + 1];
  }
  const next = await fetchPage(pageNumber + 1);
  return next && next.length > 0 ? next[0].id : null;
};

export const walkShortcutAction = ({
  key,
  repeat,
  altKey,
  ctrlKey,
  metaKey,
  shiftKey,
  tagName,
  role,
  isContentEditable
}) => {
  if (repeat || altKey || ctrlKey || metaKey || shiftKey) {
    return null;
  }
  if (
    BLOCKING_TAGS.includes(tagName) ||
    isContentEditable ||
    role === 'slider'
  ) {
    return null;
  }
  switch (key) {
    case 'ArrowLeft':
      return 'previous';
    case 'ArrowRight':
      return 'next';
    case 'e':
    case 'E':
      return 'exclude';
    case 'p':
    case 'P':
      return 'pending';
    case 'v':
    case 'V':
      return 'verified';
    default:
      return null;
  }
};
